module.exports = __webpack_public_path__ + "static/logo-f985cd548b9bf6981f4e80a563606657.jpg";